// extracted by mini-css-extract-plugin
module.exports = {"reviewsSec":"styles-module--reviews-sec--2RMEh"};